import React, { useEffect, useState, useRef } from 'react';
import {Picker} from 'antd-mobile';
import imgArrowDown from '@/assets/images/arrowDown.png';

import styles from './index.less';

const Select=(props)=>{
  const {readOnly=false,value:initValue='',list=[],placeholder,className='',label,error='',onChange=()=>{}} = props;
  const [visible,setVisible] = useState(false);
  const [value,setValue] = useState(initValue||'')
  const onClick=()=>{
    if(readOnly)return;
    setVisible(true);
  }
  return (
    <div className={styles.wrap}>
      <section className={styles.inputWrap} onClick={onClick}>
        <span className={styles.label}>{label}</span>
        <input readOnly={true} value={value} className={`${styles.input} ${className}`} type='text' placeholder={placeholder} />
        <img src={imgArrowDown} className={styles.arrowDown} />
        <Picker
          columns={list}
          visible={visible}
          onClose={() => {
            setVisible(false)
          }}
          value={value}
          onConfirm={v => {
            setValue(v[0])
            if(onChange){
              onChange(v)
            }
          }}
        />
      </section>
      <span className={styles.error}>{error||''}</span>
    </div>
    
  )
}

export default Select;